import { useState } from "react";
import { supabase } from "../supabaseClient";
import { useAuth } from "../AuthContext";

const REASONS = ["욕설/비방", "허위정보", "스팸", "기타"];

export default function ReportModal({ targetType, targetId, targetName, onClose }) {
  const { user } = useAuth();
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!reason) return;
    setLoading(true);
    setError("");
    const { error: err } = await supabase.from("reports").insert({
      reporter_user_id: user?.id,
      target_type: targetType,
      target_id: String(targetId),
      reason,
    });
    setLoading(false);
    if (err) { setError("신고 처리 중 오류가 발생했어요."); return; }
    setDone(true);
  };

  return (
    <div style={s.backdrop} onClick={onClose}>
      <div style={s.modal} onClick={(e) => e.stopPropagation()}>
        {done ? (
          <div style={{ textAlign: "center", padding: "8px 0" }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
            <div style={s.modalTitle}>신고가 접수됐어요</div>
            <p style={s.modalDesc}>검토 후 적절한 조치를 취하겠습니다.</p>
            <button style={s.primaryBtn} onClick={onClose}>확인</button>
          </div>
        ) : (
          <>
            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>🚨</div>
              <div style={s.modalTitle}>신고하기</div>
              {targetName && <p style={s.modalDesc}>"{targetName}" 신고</p>}
            </div>

            <p style={s.reasonLabel}>신고 사유를 선택해 주세요</p>
            <div style={s.reasonGrid}>
              {REASONS.map((r) => (
                <button
                  key={r}
                  style={{ ...s.reasonBtn, ...(reason === r ? s.reasonBtnActive : {}) }}
                  onClick={() => setReason(r)}
                >
                  {r}
                </button>
              ))}
            </div>

            {error && <p style={{ fontSize: 12, color: "#E24B4A", marginBottom: 12 }}>{error}</p>}

            <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
              <button style={s.cancelBtn} onClick={onClose} disabled={loading}>취소</button>
              <button
                style={{ ...s.primaryBtn, flex: 1, opacity: (!reason || loading) ? 0.5 : 1, cursor: (!reason || loading) ? "default" : "pointer" }}
                onClick={handleSubmit}
                disabled={!reason || loading}
              >
                {loading ? "신고 중..." : "신고하기"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  backdrop:        { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 300, backdropFilter: "blur(4px)" },
  modal:           { width: "90%", maxWidth: 340, background: "#fff", borderRadius: 20, padding: "24px 20px 28px", boxShadow: "0 8px 32px rgba(0,0,0,0.20)" },
  modalTitle:      { fontSize: 18, fontWeight: 700, color: "#111827", marginBottom: 6 },
  modalDesc:       { fontSize: 13, color: "#6b7280", margin: "0 0 4px" },
  reasonLabel:     { fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 10 },
  reasonGrid:      { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 18 },
  reasonBtn:       { padding: "12px 8px", background: "#f5f6fa", border: "1.5px solid #e5e7eb", borderRadius: 10, fontSize: 14, fontWeight: 600, color: "#374151", cursor: "pointer", fontFamily: "inherit" },
  reasonBtnActive: { background: "#fff5f5", borderColor: "#E24B4A", color: "#E24B4A" },
  primaryBtn:      { padding: "13px 0", background: "#E24B4A", color: "#fff", border: "none", borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: "pointer", width: "100%", fontFamily: "inherit" },
  cancelBtn:       { padding: "13px 20px", background: "#f5f6fa", color: "#6b7280", border: "1px solid #e5e7eb", borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" },
};
